module.exports = __webpack_public_path__ + "img/ft_citrus.cdc7849e.jpg";